import { useMutation, useQueryClient } from '@tanstack/react-query';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

interface CreateFilterParams {
  bundleId: string;
  rateIds: Array<string>;
}

interface DeleteFilterParams {
  bundleId: string;
  filterId: string;
}

export function useCreateBundleFilter() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bundleId, rateIds }: CreateFilterParams) => {
      return await Promise.all(rateIds.map((rateId) => bundlesService.createFilter(bundleId, { fkRateId: rateId })));
    },
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: bundleQueryKeys.filters(variables.bundleId) });
    },
  });
}

export function useDeleteBundleFilter() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bundleId, filterId }: DeleteFilterParams) => {
      return await bundlesService.deleteFilter(bundleId, filterId);
    },
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: bundleQueryKeys.filters(variables.bundleId) });
    },
  });
}
